/**
 * Normaliza texto para busca: minúsculas, sem acento e sem espaço nas pontas.
 *
 * Decompõe em NFD e remove as marcas diacríticas, em vez de descartar o que não é ASCII:
 * a segunda abordagem transformaria "Reunião" em "Reunio" e a busca por "reuniao" não
 * acharia nada — que é justamente o caso a resolver.
 *
 * Existe porque quem digita rápido não digita acento. Sem isto, procurar "area" não acha
 * "Área" e a conclusão de quem usa é que o cadastro não existe.
 */
export function normalizeForSearch(value: string): string {
  return value
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase()
    .trim();
}

/** `true` se `haystack` contém `needle`, ignorando acento e caixa. */
export function matchesSearch(haystack: string, needle: string): boolean {
  const term = normalizeForSearch(needle);

  if (term === '') return true;

  return normalizeForSearch(haystack).includes(term);
}

/**
 * Iniciais para avatar: primeira letra do primeiro nome e do último.
 *
 * Estava só no `app-sidebar`, e a lista de inscrições recentes precisava da mesma coisa —
 * duas cópias divergiriam no primeiro nome composto que aparecesse.
 *
 * Nome de uma palavra devolve UMA letra, não a mesma repetida: "Ana" vira "A", e não "AA",
 * que pareceria erro de dados. Preposição no meio não entra porque só o primeiro e o último
 * pedaço são considerados — "Maria de Souza" vira "MS".
 */
export function initialsOf(name: string): string {
  // Só a primeira letra de cada pedaço: "Admin (Dev)" vira "AD", e não "A(".
  const letters = name
    .trim()
    .split(/\s+/)
    .flatMap((part) => part.match(/\p{L}/u)?.[0] ?? []);
  const first = letters[0] ?? '';
  const last = letters.length > 1 ? (letters[letters.length - 1] ?? '') : '';

  return `${first}${last}`.toUpperCase();
}
